<template>
  <router-view />
</template>

<script setup lang="ts">
import { useLang } from '@/composables/lang';

// Nạp phiên + tiệm + theme + device đã chuyển sang `boot/initApp` (TASK-139): ở đây thì chúng chạy
// SAU lần điều hướng đầu. Chỉ locale còn lại vì `setI18nLanguage` cần router đã gắn — boot chạy
// trước khi router được gắn. `boot/i18n` đã dựng đúng locale từ cookie; lượt này chỉ còn ghi lại
// cookie (để `Accept-Language` luôn có giá trị) và nạp bundle co-locate của route đang đứng.
const { initialLocale } = useLang();
void initialLocale();
</script>
